import React from 'react';
import { Button, Divider, Icon, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import {
  informationsLinkAdd,
  initEditorInformationsLinkModalData,
  initEditorLinkModalData,
  initEditorPhoneModalData,
} from '../../../constans/controlToolbar';
import { RichUtils } from 'draft-js';
import styles from './EditorToolbar.module.scss';
import {
  inlineStyle,
  blockHeading,
  blockList,
  linkAdd,
  phoneAdd,
} from '../../../constans/controlToolbar';
import {
  InlineStyleButton,
  BlockHeadingButton,
  BlockListButton,
} from '../../components/EditorToolbar/ToolbarButton';
import ControlBtn from '../ControlBtn/ControlBtn';
import { AiOutlineLink } from 'react-icons/ai';

const EditorToolbar = ({
  onChange,
  onClose,
  className,
  toolbarCreate,
  editorStateSelector,
  closeBtn,
  setEditorLinkModalData,
  setEditorPhoneModalData,
  setEditorInformationLinkModalData,
}) => {
  const dispatch = useDispatch();
  const editorState = useSelector(editorStateSelector);

  const currentStyle = editorState.getCurrentInlineStyle();
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  const toggleInlineStyle = (style) => {
    onChange(RichUtils.toggleInlineStyle(editorState, style));
  };

  const toggleBlockType = (blockType) => {
    onChange(RichUtils.toggleBlockType(editorState, blockType));
  };

  const handleLinkBtnClick = () => {
    const data = { ...initEditorLinkModalData, visible: true };

    if (!selection.isCollapsed()) {
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getAnchorKey())
        .getText()
        .slice(start, end);

      data.text = selectedText;
    }

    dispatch(setEditorLinkModalData(data));
  };

  const handleInformationLinkBtnClick = () => {
    const data = { ...initEditorInformationsLinkModalData, visible: true };

    if (!selection.isCollapsed()) {
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getAnchorKey())
        .getText()
        .slice(start, end);

      data.text = selectedText;
    }

    setEditorInformationLinkModalData(data);
  };

  const handlePhoneBtnClick = () => {
    const data = { ...initEditorPhoneModalData, visible: true };

    if (!selection.isCollapsed()) {
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const selectedText = editorState
        .getCurrentContent()
        .getBlockForKey(selection.getAnchorKey())
        .getText()
        .slice(start, end);

      data.text = selectedText;
    }

    dispatch(setEditorPhoneModalData(data));
  };

  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.col}>
        {toolbarCreate.length
          ? toolbarCreate.map((element, index) => {
              switch (element) {
                case blockHeading:
                  return (
                    <div
                      key={index}
                      className={styles.col}
                    >
                      <BlockHeadingButton
                        onClick={toggleBlockType}
                        blockType={blockType}
                      />
                      {toolbarCreate[index + 1] ? (
                        <Divider
                          type="vertical"
                          className={styles.divider}
                        />
                      ) : null}
                    </div>
                  );
                case inlineStyle:
                  return (
                    <div
                      key={index}
                      className={styles.col}
                    >
                      <InlineStyleButton
                        onClick={toggleInlineStyle}
                        currentStyle={currentStyle}
                      />
                      {toolbarCreate[index + 1] ? (
                        <Divider
                          type="vertical"
                          className={styles.divider}
                        />
                      ) : null}
                    </div>
                  );
                case blockList:
                  return (
                    <div
                      key={index}
                      className={styles.col}
                    >
                      <BlockListButton
                        onClick={toggleBlockType}
                        blockType={blockType}
                      />
                      {toolbarCreate[index + 1] ? (
                        <Divider
                          type="vertical"
                          className={styles.divider}
                        />
                      ) : null}
                    </div>
                  );
                case linkAdd:
                  return (
                    <div
                      key={index}
                      className={styles.container}
                    >
                      <Tooltip title="Вставить ссылку">
                        <ControlBtn
                          content={
                            <AiOutlineLink className={styles.linkIcon} />
                          }
                          onClick={handleLinkBtnClick}
                        />
                      </Tooltip>
                    </div>
                  );
                case informationsLinkAdd:
                  return (
                    <div
                      key={index}
                      className={styles.container}
                    >
                      <Tooltip title="Вставить внутреннюю ссылку">
                        <ControlBtn
                          content={
                            <AiOutlineLink className={styles.linkIcon} />
                          }
                          onClick={handleInformationLinkBtnClick}
                        />
                      </Tooltip>
                    </div>
                  );
                case phoneAdd:
                  return (
                    <div
                      key={index}
                      className={styles.container}
                    >
                      <Tooltip title="Добавить номер телефона">
                        <ControlBtn
                          content={
                            <Icon
                              className={`${styles.container} ${styles.phoneIcon}`}
                              type="phone"
                            />
                          }
                          onClick={handlePhoneBtnClick}
                        />
                      </Tooltip>
                    </div>
                  );
                default:
                  return null;
              }
            })
          : null}
      </div>
      {typeof onClose === 'function' && closeBtn && (
        <Button
          icon="close"
          className={styles.closeBtn}
          onClick={onClose}
        />
      )}
    </div>
  );
};

export default EditorToolbar;
